import {
  Autocomplete,
  FormControl,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import React from "react";
import moment from "moment";

const DropdownInput = ({ input, setInput, dropdownData }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <Stack spacing={1} direction="row">
          <DesktopDatePicker
            label="From"
            variant="standard"
            fullWidth
            inputFormat="DD MMMM YYYY"
            value={input?.dateStart}
            onChange={(e) => {
              setInput((prev) => ({
                ...prev,
                dateStart: e,
                dateEnd: null,
              }));
            }}
            renderInput={(params) => (
              <TextField {...params} sx={{ backgroundColor: "#fff" }} />
            )}
            disableMaskedInput
            disableFuture
          />
          <DesktopDatePicker
            label="To"
            variant="standard"
            fullWidth
            inputFormat="DD MMMM YYYY"
            value={input?.dateEnd}
            onChange={(e) => {
              e = moment(e).hour(23).minute(59).second(59);
              setInput((prev) => ({ ...prev, dateEnd: e }));
            }}
            renderInput={(params) => (
              <TextField {...params} sx={{ backgroundColor: "#fff" }} />
            )}
            minDate={input?.dateStart || null}
            disableMaskedInput
            disableFuture
          />
        </Stack>
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <FormControl fullWidth style={{ backgroundColor: "white" }}>
          <Autocomplete
            onChange={(e, value) =>
              setInput((prev) => ({
                ...prev,
                regionId: value ? value.id : 0,
                region: value ? value : null,
                location: null,
                locationId: 0,
              }))
            }
            value={input?.region}
            getOptionLabel={(option) => option.name}
            options={dropdownData?.regional || []}
            renderInput={(params) => (
              <TextField {...params} label="Regional/Anak Perusahaan" />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xl={3} lg={3} sm={6} xs={12}>
        <FormControl fullWidth style={{ backgroundColor: "white" }}>
          <Autocomplete
            onChange={(e, value) =>
              setInput((prev) => ({
                ...prev,
                locationId: value ? value.id : 0,
                location: value ? value : null,
              }))
            }
            value={input?.location}
            getOptionLabel={(option) => option.name}
            options={dropdownData?.location || []}
            renderInput={(params) => <TextField {...params} label="Location" />}
            disabled={!input?.region}
          />
        </FormControl>
      </Grid>
      <Grid item xl={2} lg={2} sm={6} xs={12}>
        <FormControl fullWidth style={{ backgroundColor: "white" }}>
          <Autocomplete
            onChange={(e, value) => {
              setInput((prev) => ({
                ...prev,
                incidentKategoryId: value ? value.id : 0,
                incidentCategory: value ? value : null,
              }));
            }}
            value={input?.incidentCategory}
            getOptionLabel={(option) => option.name}
            options={dropdownData?.incidentCategory || []}
            renderInput={(params) => (
              <TextField {...params} label="Incident Category" />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xl={1} lg={1} sm={6} xs={12}>
        <FormControl fullWidth style={{ backgroundColor: "white" }}>
          <Autocomplete
            onChange={(e, value) => {
              setInput((prev) => ({
                ...prev,
                ReportAble: value ? value.value : null,
                ReportAbleTitle: value ? value.name : "All",
              }));
            }}
            value={input?.ReportAbleValue}
            getOptionLabel={(option) => option.name}
            options={dropdownData?.reportable || []}
            renderInput={(params) => (
              <TextField {...params} label="Reportable" />
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default DropdownInput;
